import { useCallback, useRef, useState } from 'react'
import { ApiError, worksSquareApi, type WorksSquareConfig } from '@/api'
import { useRefetchWhenLocaleChanges } from '@/shared/hooks/useLocaleRefetch'

const DEFAULT: WorksSquareConfig = {
  title: '',
  subtitle: '',
  empty: '',
  default_order_by: 'curated',
  show_category_tabs: true,
  page_size: 24,
}

export function useWorksSquareConfig() {
  const hasLoadedRef = useRef(false)
  const [config, setConfig] = useState<WorksSquareConfig>(DEFAULT)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refresh = useCallback(
    async (silent = false) => {
      if (!silent) {
        setLoading(true)
      }
      setError(null)
      try {
        const data = await worksSquareApi.config()
        setConfig({ ...DEFAULT, ...data })
        hasLoadedRef.current = true
      } catch (err) {
        const msg = err instanceof ApiError ? err.message : (err as Error).message
        setError(msg)
        if (!silent) {
          setConfig(DEFAULT)
          hasLoadedRef.current = false
        }
      } finally {
        if (!silent) {
          setLoading(false)
        }
      }
    },
    [],
  )

  useRefetchWhenLocaleChanges(refresh, hasLoadedRef)

  return { config, loading, error, refresh: () => refresh(false) }
}
